import React, { useState } from 'react';
import Select from 'react-select';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  children: React.ReactNode;
}

const Checkbox: React.FC<CheckboxProps> = ({ children, ...props }) => (
  <label style={{ marginRight: '1em' }}>
    <input type="checkbox" {...props} />
    {children}
  </label>
);

interface Option {
  value: string;
  label: string;
}

interface BaseSelectDropdownProps {
  className : string;
  classNamePrefix :string;
  isDisabled: boolean;
  isLoading : boolean;
  name: string;
  options: Option[];
  onChange: {}
  value?: { value: string; label: string };
  isClearable?:boolean
}

const BaseSelectDropdown: React.FC<BaseSelectDropdownProps> = ({ 
  className,classNamePrefix,isDisabled,isLoading,name,options,onChange,value,isClearable
}) => {

  return (
    <>
      <Select
        className={className}
        classNamePrefix={classNamePrefix}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isSearchable
        name={name}
        options={options}
        onChange={onChange}
        value={value}
      />

    </>
  );
};

export default BaseSelectDropdown;
